import { render, staticRenderFns } from "./transportistas.vue?vue&type=template&id=1b1241df&"
import script from "./transportistas.vue?vue&type=script&lang=js&"
export * from "./transportistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports